<template>
    <div id="map-wrapper">
        <div id="map-controls" class="shadow">
            <div class="text-right">
                <button class="btn btn-primary shadow btn-sm btn-map-filter-options"><span class="mr-2">FILTERS: {{ this.chivaList.length.toLocaleString() }} results</span><i
                    class="fas fa-filter"></i></button>
            </div>
            <div class="container map-filter-options d-none bg-light p-3 mt-3">
                <div class="row">
                    <div class="col-md-12 text-right">
                        <a href="javascript:void(0)" class="h4 btn-link link-black btn-map-filter-options"><i
                        class="fa fa-times"></i></a>
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Search</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="search_term" v-model="form.search_term" placeholder="Search term" />
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Status</label>
                    <div class="col-sm-10">
                        <div class="form-check form-check-inline" v-for="(item, index) in chivaStatusList" :key="item.id">
                            <input class="form-check-input" type="checkbox" v-bind:id="item" :value="item"
                                v-model="form.chiva_status">
                            <label class="form-check-label" :for="item">
                                {{ _.startCase(_.toLower(_.replace(item, "-", " "))) }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Age</label>
                    <div class="col-sm-4">
                        <input type="number" class="form-control" name="min_age_at_year_2000" v-model="form.min_age_at_year_2000" placeholder="Min.">
                    </div>
                    <div class="col-sm-1 text-center">-</div>
                    <div class="col-sm-4">
                        <input type="number" class="form-control" name="max_age_at_year_2000" v-model="form.max_age_at_year_2000" placeholder="Max.">
                    </div>
                </div>
                <div class="row mb-3">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">3D Model</label>
                    <div class="col-sm-10">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="has_3d_model" v-model="form.has_3d_model"
                                checked>
                            <label class="form-check-label" for="has_3d_model">
                                Has 3d Model
                            </label>
                        </div>
                    </div>
                </div>             
                <button class="btn btn-success mr-2" @click="handleApplyFilter"
                        :class="{'disabled': this.loadingFlag}">
                    <i class="fas fa-filter mr-2"></i>
                    <span v-if="this.loadingFlag">Loading...</span>
                    <span v-else>Apply</span>
                </button>
                <button class="btn btn-danger" @click="handleClearFilter"><i class="fas fa-undo mr-2"></i>Clear Filter</button>
            </div>
        </div><!-- /#map-controls -->
        <div id="map"></div>
    </div>
</template>
<script>
import _ from 'lodash';

export default {

    data() {
        return {
            _: _,
            map: null,
            chivaList: [],
            chivaMarkerClusterGroup: null,
            form: {
                search_term: "",
                has_3d_model: false,
                chiva_status: [],
                min_age_at_year_2000: null,
                max_age_at_year_2000: null
            },
            defaultForm: {
                search_term: "",
                has_3d_model: false,
                chiva_status: [],
                min_age_at_year_2000: null,
                max_age_at_year_2000: null
            },
            loadingFlag: false
        }
    },

    mounted() {
        // Initializing map
        this.map = L.map('map').setView([27.7172, 85.3240], 13);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);

        this.chivaMarkerClusterGroup = L.markerClusterGroup({
            showCoverageOnHover: true
        });

        this.fetchChivas();

        this.addUserMarker();

        $(".btn-map-filter-options").on('click', function () {
            $('.map-filter-options').toggleClass('d-none');
        });
    },

    methods: {
        handleApplyFilter() {
            this.chivaMarkerClusterGroup.clearLayers();
            this.fetchChivas();
        },
        fetchChivas() {
            this.loadingFlag = true;
            axios.get('/chivas', {
                params: this.form
            })
                .then(((response) => {
                    this.chivaList = response.data.chivas;
                    this.plotMarkers();
                }).bind(this))
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then((() => {
                    this.loadingFlag = false;
                }).bind(this));
        },
        addUserMarker() {
            var userLatLng = null;

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    var userMarkerIcon = new L.Icon({
                        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
                        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                        iconSize: [25, 41],
                        iconAnchor: [12, 41],
                        popupAnchor: [1, -34],
                        shadowSize: [41, 41]
                    });            

                    userLatLng = [position.coords.latitude, position.coords.longitude]
                    this.userMarker = L.marker(userLatLng, {icon: userMarkerIcon}).addTo(this.map);
                    this.userMarker.bindPopup('You are here.').openPopup();
                    this.fitBounds();
                }, (error) => {
                    switch(error.code) {
                        case error.PERMISSION_DENIED:
                        console.log("User denied the request for Geolocation.");
                        break;
                        case error.POSITION_UNAVAILABLE:
                        console.log("Location information is unavailable.");
                        break;
                        case error.TIMEOUT:
                        console.log("The request to get user location timed out.");
                        break;
                        case error.UNKNOWN_ERROR:
                        console.log("An unknown error occurred.");
                        break;
                    }
                });
            } else { 
               console.log("Geolocation is not supported by this browser.");
            }
        },
        plotMarkers() {
            this.chivaList.forEach((item) => {
                var marker = L.marker(L.latLng(item.latitude, item.longitude), {title: item.chiva_id});
                marker.bindPopup('<b>ID: </b>' + item.chiva_id + '<br />' + '<b>Chiva Status: </b>' + _.startCase(_.toLower(_.replace(item.chiva_status, "-", " "))) + '<br />' + '<b>Establisher Name: </b>' + (item.establisher_name ? item.establisher_name : "N/A") + '<br />' + '<b>Establisher Address: </b>' + (item.establisher_address ? item.establisher_address : "N/A") + '<br />' + '<b>Established Year Nepal Sambat: </b>' + (item.established_year_nepal_sambat ? item.established_year_nepal_sambat : "N/A") + '<br />' + '<b>Age At Year 2000: </b>' + (item.age_at_year_2000 ? item.age_at_year_2000 : "N/A") + '<br /><b>3D Model: </b>' + (item.model_link ? ('<a href="' + item.model_link + '" target="_blank">Link</a>') : "N/A") + '<br><a target="_blank" class"btn btn-success" href="' + window.App.appURL + '/feedbacks/create?model_type=chiva&model_id=' + item.id + '">Give More Information<i class="fas fa-arrow-right ml-1"></i></a><br /><br /><img src="' + window.App.appURL + '/images/chiva-images/tnp' + (item.chiva_id).replace("p", "") + '.jpg" width="300px" height="auto" >');
                this.chivaMarkerClusterGroup.addLayer(marker);
            });

            this.map.addLayer(this.chivaMarkerClusterGroup);
            this.fitBounds();
        },
        fitBounds() {
            var bounds = [];

            if(this.chivaList.length) {
                bounds.push(this.chivaMarkerClusterGroup.getBounds());
            }

            if(this.userMarker) {
                bounds.push(this.userMarker.getLatLng());
            }

            this.map.fitBounds(bounds);
        },
        handleClearFilter() {
            this.form = _.cloneDeep(this.defaultForm);
            this.chivaMarkerClusterGroup.clearLayers();
            this.fetchChivas();
        }
    },

    props: {
        chivaStatusList: {
            type: Object
        }
    }
}
</script>
<style>
#map-wrapper {
    position: relative;
}

#map-controls {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 999999;
}
</style>
